const fromSession = (session) => {
    return {
        token: session.token,
    };
};
let edgeUrl = '';
const getEdgeBaseUrl = () => {
    if (edgeUrl === '') {
        let currentHostname = window.location.hostname;
        let fromLocation = '';
        if (!currentHostname.includes('piccadilly') && !currentHostname.includes('localhost')) {
            const splitHostname = currentHostname.split('.');
            if (splitHostname.length >= 2) {
                fromLocation = 'https://api.' + splitHostname[splitHostname.length - 2] + '.' + splitHostname[splitHostname.length - 1];
            }
        }
        if (fromLocation !== '') {
            edgeUrl = fromLocation;
        }
        else {
            if (!process.env.REACT_APP_EDGE_URL) {
                throw new Error('edge service url is undefined');
            }
            edgeUrl = process.env.REACT_APP_EDGE_URL;
        }
    }
    return edgeUrl;
};
let etUrl = '';
const getEtUrl = () => {
    if (etUrl === '') {
        if (!process.env.REACT_APP_DISCORD_URL) {
            throw new Error('et service url is undefined');
        }
        etUrl = process.env.REACT_APP_DISCORD_URL;
    }
    return etUrl;
};
const getPostOptions = (requestBody, params) => {
    const asString = JSON.stringify(requestBody);
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Content-Length': asString.length.toString(),
            Authorization: params.token || '',
        },
        body: asString,
    };
};
const getGetOptions = (params) => {
    return {
        method: 'GET',
        headers: {
            Authorization: params.token || '',
        },
    };
};
const getPutOptions = (requestBody, params) => {
    const asString = JSON.stringify(requestBody);
    return {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Content-Length': asString.length.toString(),
            Authorization: params.token || '',
        },
        body: asString,
    };
};
const getDeleteOptions = (params) => {
    return {
        method: 'DELETE',
        headers: {
            Authorization: params.token || '',
        },
    };
};
const post = (params, basePath, path, postParams) => {
    const body = platform.getPostOptions(postParams, params);
    return platform.execute(basePath, path, body);
};
const get = (params, basePath, path) => {
    const body = platform.getGetOptions(params);
    return platform.execute(basePath, path, body);
};
const put = (params, basePath, path, putParams) => {
    const body = platform.getPutOptions(putParams, params);
    return platform.execute(basePath, path, body);
};
const deleteMethod = (params, basePath, path) => {
    const body = getDeleteOptions(params);
    return platform.execute(basePath, path, body);
};
const execute = (baseUrl, path, body) => {
    return fetch(baseUrl + path, body)
        .then((response) => response.json())
        .then((response) => {
        if (response.status === 'success') {
            logFetchResults(path, response);
            return response.data;
        }
        return Promise.reject(response);
    })
        .catch((err) => {
        logFetchResults(path, {}, err);
        return Promise.reject(err);
    });
};
const logFetchResults = (path, response, error) => {
    if (process.env.NODE_ENV === 'development' && !error) {
        const logResponse = Object.assign({}, response);
        logResponse.data = {};
        console.info('[edge] ' + path, logResponse);
    }
    else if (error) {
        console.error('[edge] ' + path, response, error);
    }
};
const buildPaginatedQuery = (request) => {
    const opts = {};
    if (request.page) {
        opts["page"] = `${request.page}`;
    }
    if (request.limit) {
        opts["limit"] = `${request.limit}`;
    }
    if (request.sortField) {
        opts["sortField"] = request.sortField;
    }
    if (request.sortDirection) {
        opts["sortDirection"] = request.sortDirection;
    }
    if (request.searchFields) {
        const searchJson = JSON.stringify(request.searchFields);
        const searchB64 = btoa(searchJson);
        opts["searchFields"] = searchB64;
    }
    if (request.searchFieldValue) {
        opts["searchFieldValue"] = request.searchFieldValue;
    }
    if (request.filters) {
        const filterJson = JSON.stringify(request.filters);
        const filterB64 = btoa(filterJson);
        opts["filters"] = filterB64;
    }
    if (request.dateRangeField) {
        opts["dateRangeField"] = request.dateRangeField;
    }
    if (request.startDate) {
        opts["startDate"] = request.startDate.toISOString();
    }
    if (request.endDate) {
        opts["endDate"] = request.endDate.toISOString();
    }
    const params = new URLSearchParams(opts);
    return params.toString();
};
const platform = {
    fromSession,
    getEdgeBaseUrl,
    getEtUrl,
    getPostOptions,
    getGetOptions,
    getPutOptions,
    getDeleteOptions,
    execute,
    post,
    get,
    put,
    deleteMethod,
    buildPaginatedQuery,
};
export default platform;
